import { jsx as y } from "react/jsx-runtime";
import { c as s } from "../../../index-Cu0xwYjD.js";
import { s as m } from "../../../Grid.module-BpY5QcAG.js";
const j = 12, v = ({
  children: n,
  className: i,
  isNested: c = !1,
  justifyContent: d = "start",
  style: a,
  offset: r
}) => {
  const l = typeof r == "number" ? r : (r == null ? void 0 : r.sm) ?? 0, p = typeof r == "number" ? r : (r == null ? void 0 : r.md) ?? 0, g = typeof r == "number" ? r : (r == null ? void 0 : r.lg) ?? (r == null ? void 0 : r.md) ?? 0;
  return /* @__PURE__ */ y(
    "div",
    {
      style: {
        "--grid-offset-sm": l,
        "--grid-offset-md": p,
        "--grid-offset-lg": g,
        ...a
      },
      className: s(
        m.row,
        {
          [m.isNested]: c,
          [m.justifyCenter]: d === "center",
          [m.justifyEnd]: d === "end",
          [m.offset]: r !== void 0
        },
        i
      ),
      children: n
    }
  );
};
export {
  j as MAX_COLS,
  v as Row
};
